import baseUrl, { image } from '../utils/data/baseUrl'
import numWord from '../utils/numWord'
import classNames from 'classnames'
import { BUTTONS, HEADER, TITLE } from '../components/modals/universalModal/constants/components'
import { ACHIEVEMENTS } from './events'
import { conturs, defaultContur, languages } from '../translations'
import { defaultStore, STORES } from '../utils/config'

export const LANGUAGE_TO_PLUG_KEY = {
  [languages.ru]: 'plug',
  [languages.kz]: 'plug_kz',
  [languages.ar]: 'plug_ar',
  [languages.en]: 'plug_en',
}

export const getPlugKeyByLanguage = (language) => LANGUAGE_TO_PLUG_KEY[language] ?? 'plug'

export const goldenAppleBrands = {
  forMe: 'https://goldapple.ru/brands/forme',
}

export const levelModalContent = {
  description: 'levelModalContent.description',
  buttons: [
    {
      attr: {
        text: 'levelModalContent.buttons.0.text',
        className: 'w-modal__button button_win button_green',
      },
      isClose: true,
    },
  ],
  buttonPromocode: {
    attr: {
      text: 'levelModalContent.buttonPromocode.text',
      tag: 'a',
      target: '_blank',
      className: 'w-modal__button button_win button_green',
    },
  },
}

export const inactiveGameModalFound = {
  title: 'inactiveGameModalFound.title',
}

export const inactiveGameRefactoring = {
  image: image('inactiveGame/hello-elf.png'),
  icon: 'logo_ga',
  title: 'inactiveGameRefactoring.title',
  description: 'inactiveGameRefactoring.description',
  mod: 'not-found',
  copyright: 'header.copyright',
  isSelectLangButton: true,
  button: {
    text: 'inactiveGameRefactoring.button.text',
    tag: 'a',
    href: 'https://goldapple.ru',
    target: '_blank',
  },
}

export const inactiveGameModalNotFound = {
  icon: 'logo_ga',
  title:
    defaultContur === conturs.me
      ? 'inactiveGameModalNotFound.meTitle'
      : 'inactiveGameModalNotFound.title',
  description: 'inactiveGameModalNotFound.description',
  mod: 'not-found',
  copyright: 'header.copyright',
}

export const taskCompleteModalContent = {
  title: 'taskCompleteModalContent.title',
  note: 'taskCompleteModalContent.note',
  premiumNote: {
    premium: 'taskCompleteModalContent.premiumNote.premium',
    standard: 'taskCompleteModalContent.premiumNote.standard',
  },
  promoCopy: {
    texts: {
      copyPromocode: 'taskCompleteModalContent.promoCopy.texts.copyPromocode',
      copiedPromocode: 'taskCompleteModalContent.promoCopy.texts.copiedPromocode',
    },
  },
  link: {
    text: 'taskCompleteModalContent.link.text',
    href: baseUrl('docs/Правила_проведения.pdf'),
  },
  buttonPrem: {
    tag: 'button',
    text: 'taskCompleteModalContent.buttonPrem.text',
    className: 'custom-button custom-button_blue task-complete-modal__button',
  },
  buttonContinue: {
    text: 'taskCompleteModalContent.buttonContinue.text',
    tag: 'button',
    className: 'custom-button task-complete-modal__button',
  },
}

export const loseQuizContent = {
  title: 'loseQuizContent.title',
  text: 'loseQuizContent.text',
  buttons: [
    // {
    //   action: "reset",
    //   attr: {
    //     text: "loseQuizContent.buttons.0.text",
    //     className: "custom-button lose-modal__button"
    //   }
    // },
    {
      action: 'home',
      attr: {
        text: 'loseQuizContent.buttons.1.text',
        className: 'custom-button custom-button_gray lose-modal__button',
      },
    },
  ],
}

export const procedureModal = {
  goProcedure: 'procedureModal.goProcedure',
  disabledNote: (_, t) => t('procedureModal.disabledNote'),
  enabledNote: (num, t) =>
    t('procedureModal.enabledNote', {
      num: num,
      available: numWord(num, [
        t('procedureModal.available.0'),
        t('procedureModal.available.1'),
        t('procedureModal.available.2'),
      ]),
      routine: numWord(num, [
        t('procedureModal.routine.0'),
        t('procedureModal.routine.1'),
        t('procedureModal.routine.2'),
      ]),
    }),
  noMoneyData: {
    title: 'procedureModal.noMoneyData.title',
    subTitle: 'procedureModal.noMoneyData.subTitle',
    buttons: [
      {
        attr: {
          text: 'procedureModal.noMoneyData.buttons.0.text',
          className: 'buy-modal__button lose-modal__button custom-button_price',
        },
        action: 'cancel',
      },
    ],
  },
}

export const pauseModal = {
  continueText: 'pauseModal.continueText',
  exitText: 'pauseModal.exitText',
}

export const promoModal = {
  title: 'Как в салоне!',
  description:
    'До 28 декабря заходи в телеграм-бот, проходи бьюти-тест, получи персональную подборку ухода для волос и мастер-класс от звездного стилиста!',
  img: image('promo/promo.png'),
  buttons: [
    {
      text: 'В чат-бот',
      tag: 'a',
      isLink: true,
      target: '_blank',
      href: 'https://t.me/GAhairbot?utm_source=spetsproekt&utm_medium=tamagotchi&utm_campaign=ru_ga_spetsproekt_tamagotchi_game_brand_zone',
    },
    {
      text: 'назад в игру',
      className: 'custom-button_gray',
    },
  ],
}

export const getGiftMeShopHref = () => {
  switch (defaultStore) {
    case STORES.qa:
      return 'https://goldapple.qa/offer/birthday-gifts-1-6-26'
    case STORES.ae:
      return 'https://goldapple.ae/offer/birthday-gifts-1-6-26'
    case STORES.sa:
      return 'https://goldapple.sa/offer/birthday-gifts-1-6-26'
    default:
      return 'https://goldapple.ae/offer/birthday-gifts-1-6-26'
  }
}

export const giftMeModalContent = {
  title: 'giftMeModalContent.title',
  description: 'giftMeModalContent.description',
  buttons: [
    {
      text: 'giftMeModalContent.buttons.0.text',
      className: 'custom-button custom-button_yellow',
      tag: 'a',
      isLink: true,
      target: '_blank',
      href: getGiftMeShopHref(),
    },
    {
      text: 'giftMeModalContent.buttons.1.text',
      className: 'custom-button custom-button_gray',
    },
  ],
}

export const promoTeensModalBot = {
  title: 'Еще больше призов',
  description:
    'Нашли еще одну интересную игру в телеграм-боте @GAteens_bot — там ты сможешь проходить квизы, получать бонусы на свою карту лояльности и ставить рекорды в GA Blast!',
  img: image('teensModals/teensBot.png'),
  buttons: [
    {
      text: 'Перейти в бот',
      tag: 'a',
      isLink: true,
      target: '_blank',
      href: 'https://t.me/GAteens_bot?utm_source=spetsproekt&utm_medium=tamagotchi&utm_campaign=ru_ga_spetsproekt_tamagotchi_game_tg',
    },
    {
      text: 'вернуться в игру',
      className: 'custom-button_gray',
    },
  ],
}

export const promoTeensModalTelegram = {
  title: 'Кое-что интересное',
  description:
    'Кстати, поговаривают, что в телеграм-канале @goldapple_teens можно узнавать о новостях бьюти-мира, скидках и конкурсах. Переходи и убедись!',
  img: image('teensModals/teensTelegram.png'),
  buttons: [
    {
      text: 'Перейти в канал',
      tag: 'a',
      isLink: true,
      target: '_blank',
      href: 'https://t.me/goldapple_teens?utm_source=spetsproekt&utm_medium=tamagotchi&utm_campaign=ru_ga_spetsproekt_tamagotchi_game_tg',
    },
    {
      text: 'вернуться в игру',
      className: 'custom-button_gray',
    },
  ],
}

export const esteeLauderModal = {
  title: 'Тон на миллион',
  description:
    'Пробуй усовершенствованный тональный крем Estee Lauder Double Wear Stay-in-Place Makeup и участвуй в розыгрыше <br>1 000 000 бонусов в телеграм-боте!',
  img: image('esteeLauder/esteeLauder.png'),
  buttons: [
    {
      text: 'Хочу',
      tag: 'a',
      isLink: true,
      target: '_blank',
      href: 'https://t.me/EsteeLauderGAbot?utm_source=spetsproekt&utm_medium=tamagotchi&utm_campaign=sa_ga_spetsproekt_tamagotchi_game_brand_zone',
    },
    {
      text: 'Вернуться в игру',
      className: 'custom-button_gray',
    },
  ],
}

export const januaryBonusModal = {
  title: 'junuaryBonusModal.title',
  description: 'junuaryBonusModal.description',
  img: image('junuaryModal/promo.png'),
}

export const newSeasonModal = {
  title: 'newSeasonModal.title',
  description: 'newSeasonModal.description',
  img: image('newSeason/img.png'),
  button: 'newSeasonModal.button',
}

export const newSeasonRatingModal = {
  title: 'newSeasonRatingModal.title',
  description: 'newSeasonRatingModal.description',
  img: image('new-season-rating/img.png'),
  button: 'newSeasonRatingModal.button',
}

export const dailyAttemptsModal = {
  energyText: {
    premium: 'dailyAttemptsModal.energyText.premium',
    standard: 'dailyAttemptsModal.energyText.standard',
  },
  buttonPrem: {
    tag: 'button',
    text: 'dailyAttemptsModal.buttonPrem.text',
    className: 'custom-button custom-button_blue task-complete-modal__button',
  },
  buttonContinue: {
    text: 'dailyAttemptsModal.buttonContinue.text',
    tag: 'button',
    className: 'custom-button task-complete-modal__button',
  },
  title: 'dailyAttemptsModal.title',
  description: 'dailyAttemptsModal.description',
}

export const giftModal = {
  termOfUseText: 'giftModal.termOfUseText',
}

export const gameResultModalContent = {
  title: 'gameResultModalContent.title',
  count: 50,
  rating: {
    title: 'gameResultModalContent.rating.title',
  },
  buttons: [
    {
      text: 'gameResultModalContent.buttons.0.text',
      tag: 'a',
      isLink: true,
      target: '_blank',
      className:
        'custom-button custom-button_yellow quiz-win-modal__button procedure-result-modal__button procedure-result-modal__button_buy',
    },
    {
      text: 'gameResultModalContent.buttons.1.text',
      className:
        'custom-button custom-button_white quiz-win-modal__button procedure-result-modal__button',
      action: 'toGames',
    },
  ],
}

export const procedureGameResultContent = {
  title: 'procedureGameResultContent.title',
  buttons: [
    {
      action: 'sets',
      attr: {
        text: 'procedureGameResultContent.buttons.0.text',
        className: 'custom-button lose-modal__button',
        gtm: 'GTMBeautyRoutineProducts',
      },
    },
    {
      action: 'home',
      attr: {
        text: 'procedureGameResultContent.buttons.1.text',
        className: 'custom-button custom-button_ny-gray lose-modal__button',
        gtm: 'GTMBeautyRoutineContinue',
      },
    },
  ],
}

export const procedureGameSelectionContent = {
  title: 'procedureGameSelectionContent.title',
  button: {
    action: 'buy',
    attr: {
      text: 'procedureGameSelectionContent.button.text',
      className: 'custom-button selection-modal__button procedure-game-selection__button',
    },
  },
}

export const converterModalContent = {
  rulesButton: {
    attr: {
      icon: 'buttons/info',
      className: 'custom-button_icon converter-modal__rules',
    },
  },
  title: {
    previous: 'converterModalContent.title.previous',
    new: 'converterModalContent.title.new',
  },
  text: {
    gift: 'converterModalContent.text.gift',
    beauties: 'converterModalContent.text.beauties',
  },
  maxConvertPerDay: {
    gift: 'converter.maxConvertPerDay.gift',
    beauties: 'converter.maxConvertPerDay.beauties',
  },
  note: {
    text: 'converterModalContent.note.text',
  },
  warning: {
    gifts: (converted, limit, gifts, proportion) => {
      if (gifts < proportion) {
        return 'converterModalContent.warning.gifts.text1'
      } else if (converted >= limit) {
        return 'converterModalContent.warning.gifts.text2'
      } else {
        return null
      }
    },
    beauties: (converted, limit, gifts, proportion) => {
      if (gifts < proportion) {
        return 'converterModalContent.warning.beauties.text1'
      } else if (converted >= limit) {
        return 'converterModalContent.warning.beauties.text2'
      } else {
        return null
      }
    },
  },
  converterIcons: {
    energy: {
      imgAttr: {
        src: image('reward/energy.png'),
      },
    },
    gift: {
      imgAttr: {
        src: image('reward/gift.png'),
      },
    },
    bonuses: {
      imgAttr: {
        src: image('reward/bonuses.png'),
      },
    },
    beauties: {
      imgAttr: {
        src: image('reward/beauties-converter.png'),
      },
    },
  },
  buttons: [
    {
      action: 'exchange',
      attr: {
        text: () => 'converterModalContent.buttons.0.text',
        className: 'custom-button custom-button_green converter-modal__exchange',
        gtm: 'GTMEnergyExchange',
      },
    },
    {
      action: 'cancel',
      attr: {
        text: () => 'converterModalContent.buttons.1.text',
        className: 'custom-button custom-button_gray converter-modal__cancel',
      },
    },
  ],
}

export const convertRulesModal = {
  back: {
    attr: {
      icon: 'buttons/back',
      className: 'custom-button_icon text-modal__back',
    },
  },
  gifts: {
    title: 'convertRulesModal.gifts.title',
    text: 'convertRulesModal.gifts.text',
  },
  beauties: {
    title: 'convertRulesModal.beauties.title',
    text: 'convertRulesModal.beauties.text',
  },
}

export const converterResultModal = {
  modalType: 'wModal',
  type: 'converterResult',
  rewards: [{ type: 'energy', value: '300' }],
  title: 'converterResultModal.title',
  description: {
    gifts: (converted, limit, gifts, proportion) => {
      if (converted >= limit) {
        return 'converterResultModal.description.gifts.text1'
      } else if (gifts < proportion) {
        return 'converterResultModal.description.gifts.text2'
      } else {
        return 'converterResultModal.description.gifts.text3'
      }
    },
    beauties: (converted, limit, gifts, proportion) => {
      if (converted >= limit) {
        return 'converterResultModal.description.beauties.text1'
      } else if (gifts < proportion) {
        return 'converterResultModal.description.beauties.text2'
      } else {
        return 'converterResultModal.description.beauties.text3'
      }
    },
  },
  noteValue: {
    gifts: 'converterResultModal.noteValue.gifts',
    beauties: 'converterResultModal.noteValue.beauties',
  },
  buttons: [
    {
      attr: {
        text: () => 'converterResultModal.buttons.0.text',
        className: 'custom-button custom-button_yellow',
      },
      goConverter: true,
    },
    {
      attr: {
        text: () => 'converterResultModal.buttons.1.text',
        className: 'custom-button custom-button_gray',
      },
      isClose: true,
    },
  ],
  selfClose: true,
}

export const promocodeModal = {
  title: 'promocodeModal.title',
  subtitle: 'promocodeModal.subtitle',
  text: 'promocodeModal.text',
  promoCode: 'FORME25',
  buttons: [
    {
      attr: {
        tag: 'a',
        target: '_blank',
        href: goldenAppleBrands.forMe,
        text: 'promocodeModal.buttons.0.text',
        className: 'promocode-modal__button custom-button custom-button_yellow',
      },
    },
    {
      attr: {
        text: 'promocodeModal.buttons.1.text',
        className: 'promocode-modal__button custom-button custom-button_gray',
      },
      action: 'close',
    },
  ],
}

export const savePostcardModalContent = {
  title: 'savePostcardModalContent.title',
  text: 'savePostcardModalContent.text',
  button: {
    attr: {
      text: 'savePostcardModalContent.button.text',
      className: 'save-postcard-modal__button',
    },
  },
}

export const passModalContent = {
  img: image('pass/bg.png'),
  title: 'passModalContent.title',
  subtitle: 'passModalContent.subtitle',
  bonuses: [
    [
      {
        img: image('pass/1.svg'),
        text: 'passModalContent.bonuses.0.text',
      },
      {
        img: image('pass/2.svg'),
        text: 'passModalContent.bonuses.1.text',
      },
      {
        img: image('pass/3.svg'),
        text: 'passModalContent.bonuses.2.text',
      },
      {
        img: image('pass/4.svg'),
        text: 'passModalContent.bonuses.3.text',
      },
    ],
    [
      {
        img: image('pass/1.svg'),
        text: 'passModalContent.bonuses.0.text',
      },
      {
        img: image('pass/2.svg'),
        text: 'passModalContent.bonuses.1.text',
      },
      {
        img: image('pass/3.svg'),
        text: 'passModalContent.bonuses.2.text',
      },
      {
        img: image('pass/4.svg'),
        text: 'passModalContent.bonuses.3.text',
      },
    ],
    [
      {
        img: image('pass/1.svg'),
        text: 'passModalContent.bonuses.0.text',
      },
      {
        img: image('pass/2.svg'),
        text: 'passModalContent.bonuses.1.text',
      },
      {
        img: image('pass/3.svg'),
        text: 'passModalContent.bonuses.2.text',
      },
      {
        img: image('pass/4.svg'),
        text: 'passModalContent.bonuses.3.text',
      },
    ],
  ],
  note: 'passModalContent.note',
  note2: 'passModalContent.note2',
  sign: 'passModalContent.sign',
  items: [
    { img: image('pass/1.png'), isDone: true },
    { img: image('pass/2.png'), isButton: true },
    { img: image('pass/3.png') },
    { img: image('pass/4.png') },
    { img: image('pass/5.png') },
    { img: image('pass/6.png') },
    { img: image('pass/7.png') },
    { img: image('pass/8.png') },
    { img: image('pass/9.png') },
    { img: image('pass/10.png') },
    { img: image('pass/11.png') },
  ],
  link: {
    className: 'pass-modal__link custom-button_transparent custom-button_link',
    text: 'passModalContent.link.text',
  },
  buttons: [
    {
      action: 'buy',
      text: 'passModalContent.buttons.0.text',
      timeout: 2000,
      image: image('reward/gift.png'),
      count: true,
      className: 'custom-button custom-button_yellow custom-button_wish-coin pass-modal__button',
    },
    {
      action: 'close',
      text: 'passModalContent.buttons.1.text',
      className: 'custom-button custom-button_gray pass-modal__button',
    },
  ],
  buyButtons: [
    {
      attr: {
        text: 'passModalContent.buyButtons.0.text',
        className:
          'buy-modal__button lose-modal__button custom-button_price custom-button_wish-coin',
      },
      action: 'buy',
    },
    {
      attr: {
        text: 'passModalContent.buyButtons.1.text',
        className: 'buy-modal__button custom-button_gray lose-modal__button',
      },
      action: 'cancel',
    },
  ],
}

export const aboutSubscription = {
  slides: [
    {
      title: 'aboutSubscription.slides.0.title',
      text: ['aboutSubscription.slides.0.text'],
      buttons: [{ attr: { text: 'aboutSubscription.slides.0.buttons.0.text' }, action: 'next' }],
    },
  ],
}

export const shopModal = {
  buttons: {
    buy: {
      attr: {
        className: 'shop-modal__buy custom-button_green',
      },
      text: {
        have: 'shopModal.buttons.buy.text.have',
        dontHave: 'shopModal.buttons.buy.text.dontHave',
      },
    },
    favorites: {
      attr: {
        icon: 'buttons/heart',
        className: 'shop-modal__favorite custom-button_favorite custom-button_gray',
      },
    },
    elfBuy: {
      attr: {
        className: 'shop-modal__elf-buy custom-button_gray custom-button_wish-coin',
      },
      text: {
        absent: 'shopModal.buttons.elfBuy.text.absent',
        unequipped: 'shopModal.buttons.elfBuy.text.unequipped',
      },
      icon: { equipped: 'equipped' },
    },
  },
}

export const buyBeautiesModal = {
  buttons: {
    buy: {
      attr: {
        className: 'buy-beauties-modal__buy custom-button_green',
      },
      text: {
        have: 'buyBeautiesModal.buttons.buy.text.have',
        dontHave: 'buyBeautiesModal.buttons.buy.text.dontHave',
        noCurrency: 'buyBeautiesModal.buttons.buy.text.noCurrency',
      },
    },
    favorites: {
      attr: {
        icon: 'buttons/heart',
        className: 'buy-beauties-modal__favorite custom-button_favorite custom-button_gray',
      },
    },
    elfBuy: {
      attr: {
        className: 'buy-beauties-modal__elf-buy custom-button_gray custom-button_wish-coin',
      },
      text: {
        absent: 'buyBeautiesModal.buttons.elfBuy.text.absent',
        unequipped: 'buyBeautiesModal.buttons.elfBuy.text.unequipped',
      },
      icon: { equipped: 'equipped' },
    },
  },
}

export const raffleSlideContent = {
  slides: [
    {
      title: 'raffleSlideContent.slides.0.title',
      text: ['raffleSlideContent.slides.0.text'],
      buttons: [{ attr: { text: 'raffleSlideContent.slides.0.buttons.0.text' }, action: 'next' }],
      img: image('raffle/tickets-raffle.png'),
    },
    {
      title: 'raffleSlideContent.slides.1.title',
      text: ['raffleSlideContent.slides.1.text'],
      buttons: [{ attr: { text: 'raffleSlideContent.slides.1.buttons.0.text' }, action: 'next' }],
      img: image('raffle/raffle-elf.png'),
    },
  ],
}

export const challengeInfoModalContent = {
  type: 'noImg',
  title: 'challengeInfoModalContent.title',
  description: ['challengeInfoModalContent.text'],
  buttons: [
    {
      className: classNames('about-modal__button'),
      text: 'challengeInfoModalContent.buttons.0.text',
      action: 'close',
    },
  ],
}

export const shopInfoModalContent = {
  type: 'noImg',
  title: 'shopInfoModalContent.title',
  description: ['shopInfoModalContent.text'],
  buttons: [
    {
      className: classNames('about-modal__button'),
      text: 'shopInfoModalContent.buttons.0.text',
      action: 'close',
      redirect: 'shelf',
    },
  ],
}

export const quizWinModalContent = {
  link: {
    attr: {
      target: '_blank',
      className: 'quiz-win-modal__promocode-link',
    },
    text: 'quizWinModalContent.link.text',
  },
  promocodeButton: {
    attr: {
      text: 'quizWinModalContent.promocodeButton.text',
      tag: 'a',
      target: '_blank',
      className: 'quiz-win-modal__button',
    },
  },
}

export const quizWinnerModalContent = {
  link: {
    attr: {
      target: '_blank',
      className: 'quiz-win-modal__promocode-link',
    },
    text: 'quizWinnerModalContent.link.text',
  },
  promocodeButton: {
    attr: {
      text: 'quizWinnerModalContent.promocodeButton.text',
      tag: 'a',
      target: '_blank',
      className: 'quiz-win-modal__button',
    },
  },
  shopButton: {
    text: 'quizWinnerModalContent.shopButton.text',
    tag: 'a',
    target: '_blank',
    className: 'custom-button_gray quiz-win-modal__button',
  },
}

export const procedurePrizeContent = {
  title: 'procedurePrizeContent.title',
  buttons: [
    {
      attr: {
        className: classNames('quiz-winner-modal__button', 'custom-button_green'),
        text: 'procedurePrizeContent.buttons.0.text',
      },
      action: 'toShop',
    },
    {
      attr: {
        className: classNames('quiz-winner-modal__button', 'custom-button_gray'),
        text: 'procedurePrizeContent.buttons.1.text',
      },
      action: 'close',
    },
  ],
}

export const elfNewClothesModalContent = {
  title: 'elfNewClothesModalContent.title',
  text: 'elfNewClothesModalContent.text',
  image: image('elf-new-clothes.png'),
  buttons: [
    {
      attr: {
        className: 'custom-button_green temp-promo-modal__button',
        text: 'elfNewClothesModalContent.buttons.0.text',
      },
      action: 'redirect',
    },
    {
      attr: {
        className: 'custom-button_gray temp-promo-modal__button',
        text: 'elfNewClothesModalContent.buttons.1.text',
      },
      action: 'close',
    },
  ],
}

export const newYearModalChallengesContent = {
  type: 'halloween',
  title: 'newYearModalChallengesContent.title',
  description: 'newYearModalChallengesContent.text',
  buttons: [
    {
      className: classNames('about-modal__button'),
      text: 'other.super',
    },
  ],
  img: image('ny/challenges.png'),
}

export const giftNoticeClothContent = {
  title: 'giftNoticeContent.youGift',
  type: 'cloth',
  subTitle: 'wishContent.myGiftNotification.subTitle',
  buttons: [
    {
      attr: {
        text: 'other.pickUpGift',
        modalData: { action: 'close', data: { type: 'current' } },
        className: 'gift-notice__button',
      },
    },
  ],
}

export const giftNoticeWishContent = {
  type: 'card',
  title: 'giftNoticeContent.youCard',
  subTitle: 'wishContent.myGiftNotification.subTitle',
  buttons: [
    {
      attr: {
        text: 'other.watchPostcard',
        modalData: { action: 'open', data: { type: 'myGiftImageModal', props: {} } },
        className: 'gift-notice__button',
      },
    },
    {
      attr: {
        text: 'other.continue',
        className: 'custom-button_gray gift-notice__button gift-notice__button_continue',
        modalData: { action: 'close', data: { type: 'current' } },
      },
    },
  ],
}

export const friendAchievementsContent = {
  modalProps: { wrapper: { isFullPage: true }, modifier: ['friend-achievements'] },
  components: [
    {
      type: HEADER,
      props: {
        back: {
          toPrevState: false,
          button: {
            modalData: { action: 'close', data: { type: 'current' } },
          },
        },
      },
    },
    {
      type: TITLE,
      props: {
        value: 'other.friendsAchievements',
      },
    },
  ],
}

export const profileModalContent = {
  buttons: [
    {
      event: ACHIEVEMENTS,
      className: 'profile-modal__button',
      text: 'other.friendsAchievements',
      callbackKey: 'getIconsByUid',
      timeout: 2000,
      uid: null,
    },
  ],
}

export const newAchievementContent = {
  modalProps: { wrapper: { isFullPage: false }, modifier: 'noFullNoScroll' },
  components: [
    {
      type: TITLE,
      props: {
        modifier: 'padding-no',
        value: 'newAchievementContent.title',
      },
    },
    {
      type: BUTTONS,
      props: {
        buttons: [
          {
            modalData: { action: 'close', data: { type: 'current' } },
            text: 'other.continue',
          },
        ],
      },
    },
  ],
}
